import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

// Define a type for route names object
type RouteNames = {
  [key: string]: string;
};

const routeNames: RouteNames = {
  "": "Timesheet",
  iontime: "Timesheet",
  mytimesheetreport: "My Timesheet",
  timesheetReport: "Missing TS Report",
  projectTimesheetsReport: 'Project Timesheets Reports',
  timesheets: "Employee Timesheet Reports",
  manageproject: "Manage Project",
  createProject: "Create",
  updateProject: "Update",
  client: "Manage Client",
  createclient: "Create",
  updateclient: "Update",
  createclientproject: "Create Project",
  updateclientproject: "Update Project",
  approveRejectList: "Approve/Reject Report List",
  reviewApproveTimesheet: "Approve/Reject Report",
  employeeskills: "Employee Skills",
  skillsreport: 'Employee Skills Report',
  ipms: "IPMS",
  ipmsassessment: "Performance Assessment",
  goal: "Add/Edit Goal",
  goalassessment: "Performance Assessment Review",
  employeegoals: "Employee Goal View",
  employeeGoalAssessment: "Performance Assessment View",
  employeeFinalGoalAssessment: "Final Performance Assessment View",
  manageGoals: "Manage Goals",
  admin: "Admin",
  department: "Department",
  role: "Role",
  user: "User",
  create: "Create",
  update: "Update",
  leaveReports: "Leave Reports",
  discrepancyReports: "Discrepancy Reports",
  movementregister: "Movement Register",
  exporttimesheets: "Export Timesheets",
  monthlyfinanceReport: "Utilisation Report",
  employees_list: "Employee List",
  assign_manager: "Change Appraiser",
  ipmsreport: 'Reports',
  employeeAssignmentDirectory: "Employee Assignment Directory",
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  // console.log(pathnames, 'routeKey')
  // Generate breadcrumbs dynamically based on current path
  const breadcrumbs = pathnames.map((name, index) => {
    const routePath = `/${pathnames.slice(0, index + 1).join("/")}`;
    const routeKey = pathnames[index] || ""; // Default to empty string for root
    const isLast = index === pathnames.length - 1;
    // console.log(routeKey, "routeKey", routePath);
    return (
      <li key={routeKey} className='inline-flex items-center'>
        {index !== 0 && <ChevronRightIcon className='h-4 w-4 text-gray-500' />}
        {!isLast ? (
          <Link
            to={routePath === "/admin" ? "/" : routePath}
            className='ms-1 text-md font-medium text-gray-700 hover:text-blue-600 md:ms-2 dark:text-gray-400 dark:hover:text-white'
          >
            {routeNames[routeKey] || name}
          </Link>
        ) : (
          <span className='ms-1 text-md font-medium text-gray-700 md:ms-2 dark:text-gray-400'>
            {routeKey === "admin" ? routeNames["iontime"] : routeNames[routeKey] || name}
          </span>
        )}
      </li>
    );
  });

  return (
    breadcrumbs && (
      <nav className='flex justify-between items-center 2xl:container mx-auto' aria-label='Breadcrumb'>
        <ol className='inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse'>{breadcrumbs}</ol>
      </nav>
    )
  );
}
